import devStorage from './devStorage';

export default {
  transformRequest(data, headers) {
    const { fakeIdentity } = devStorage.user || {};
    if (fakeIdentity) {
      headers.common = {
        ...headers.common,
        'X-Integration-Testing': '{950522A9-48E1-4B63-AF0C-212ADB01D426}',
        'X-Fake-Identity': JSON.stringify(fakeIdentity),
      };
    }

    return data;
  },
};
